/**
 * Utilitários para integração com WhatsApp
 */

/**
 * Gera uma mensagem de texto simples para copiar
 */
export const generateWhatsAppMessage = (
  reservaId: string,
  clienteNome: string
): string => {
  const baseUrl = window.location.origin;
  const reservaLink = reservaId
    ? `${baseUrl}/reserva/${reservaId}`
    : baseUrl;

  return `Olá ${clienteNome || 'Cliente'}! 👋

🎉 *Sua reserva foi confirmada com sucesso!*

🔗 *Acesse os detalhes da sua reserva:*
${reservaLink}

Qualquer dúvida, estamos à disposição 😊`;
};


/**
 * Abre o WhatsApp com a mensagem formatada
 */
export const openWhatsApp = (telefone: string, reservaId: string, clienteNome: string): void => {
  try {
    // Remove caracteres não numéricos do telefone
    const cleanPhone = telefone.replace(/\D/g, '');

    // Se o telefone estiver vazio, avisa e retorna
    if (!cleanPhone) {
      alert('Telefone inválido ou não informado.');
      return;
    }

    // Adiciona código do país se não tiver (assumindo Brasil)
    // Se tiver 10 ou 11 dígitos, assume que falta o 55
    const phoneWithCountryCode = cleanPhone.length <= 11 && !cleanPhone.startsWith('55')
      ? `55${cleanPhone}`
      : cleanPhone;

    // Gera a mensagem
    const message = generateWhatsAppMessage(reservaId, clienteNome);
    const encodedMessage = encodeURIComponent(message);

    console.log('Gerando link WhatsApp:', { phone: phoneWithCountryCode, message });

    // Usa a URL universal da API que permite ao usuário escolher 
    // entre abrir no App instalado ou no WhatsApp Web
    const url = `https://api.whatsapp.com/send?phone=${phoneWithCountryCode}&text=${encodedMessage}`;

    // Abre a janela
    // 'whatsapp_envio' é o nome da janela/aba. O browser tentará reutilizar abas com este nome.
    const win = window.open(url, 'whatsapp_envio');

    // Foca na janela se ela já existir
    if (win) {
      win.focus();
    }
  } catch (error) {
    console.error('Erro ao abrir WhatsApp:', error);
    alert('Erro ao tentar abrir o WhatsApp. Verifique se o bloqueador de popvups está ativo.');
  }
};

/**
 * Copia a mensagem para a área de transferência
 */
export const copyWhatsAppMessage = async (reservaId: string, clienteNome: string): Promise<boolean> => {
  try {
    const message = generateWhatsAppMessage(reservaId, clienteNome);
    await navigator.clipboard.writeText(message);
    return true;
  } catch (error) {
    console.error('Erro ao copiar mensagem:', error);
    return false;
  }
};

/**
 * Gera um link do WhatsApp com mensagem formatada para reserva (legado/alternativo)
 */
export const generateWhatsAppLink = (telefone: string, reservaId: string, clienteNome: string): string => {
  const cleanPhone = telefone.replace(/\D/g, '');
  const phoneWithCountryCode = cleanPhone.startsWith('55') ? cleanPhone : `55${cleanPhone}`;
  const message = generateWhatsAppMessage(reservaId, clienteNome);
  return `https://wa.me/${phoneWithCountryCode}?text=${encodeURIComponent(message)}`;
};
